export default __webpack_public_path__ + "static/media/inactive-stat-icon.589b4919.svg";